export const yesBtnCls = "bg-yes-subtle text-yes active:bg-yes active:!text-content-fixed-inverse";
export const noBtnCls = "bg-no-subtle text-no active:bg-no active:!text-content-fixed-inverse";
export const shadowCls = "overflow-hidden border border-stroke shadow-[0_8px_16px_0_rgba(0,0,0,0.04)]";
export const baseCardCls = "bg-surface-card p-3 rounded-xl";
export const baseBrandCls =
    "absolute top-0 left-0 box-content text-[10px] h-3 font-semibold px-1 rounded-tl-md rounded-br-md rounded-bl-none rounded-tr-none bg-gradient-to-r flex items-center justify-center";
export const yesBrandCls = "from-yes-badge-from to-yes-badge-to text-yes";
export const noBrandCls = "from-no-badge-from to-no-badge-to text-no";
export const disableCls = "cursor-not-allowed opacity-40";
export const yesBgCls = "bg-yes-subtle";
export const noBgCls = "bg-no-subtle";
